import * as React from 'react';
import JumpLink from '../components/JumpLink';
import { styled } from '@zoopla-eng/zds-components/themes';

const Text = styled('p', {
    margin: 0,
    fontGroup: 'ladle',
    color: '$textBody'
});

const Heading2 = styled('h2', {
    margin: 0,
    fontGroup: 'teapot',
    color: '$textTitle',
    fontWeight: '$400'
});

const Heading3 = styled('h3', {
    margin: 0,
    fontGroup: 'kettle',
    color: '$textTitle',
    fontWeight: '$400'
});

const Heading4 = styled('h4', {
    margin: 0,
    fontGroup: 'plate',
    color: '$textTitle',
    fontWeight: '$400'
});

export const renderHeadingOrJumpLink = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _node: Record<string, any>,
    children: React.ReactNode
) => {
    const type = _node?.nodeType;
    const text = _node?.content[0]?.value;

    // If we have no text but children then it is likely the whole heading is a link, and we
    // don't want to create JumpLinks around real links. Ideally article headings should not
    // be links but we must support them for legacy articles.
    if (!text && children) {
        switch (type) {
            case 'heading-2':
                return <Heading2>{children}</Heading2>;
            case 'heading-3':
                return <Heading3>{children}</Heading3>;
            case 'heading-4':
                return <Heading4>{children}</Heading4>;
            default:
                return <Text>{children}</Text>;
        }
    }
    return (
        <JumpLink type={type} text={text}>
            {children}
        </JumpLink>
    );
};
